// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__2F0OT","resendInfoText":"OnGoingPaymentBox_resendInfoText__2MfHy"};